import bop, { transform } from '../../../../bop';
import * as Error from '../../utils/error';
import * as TeamErrors from '../../errors/team';

const fetchTeamUrl = (payload) => {
    const { userId, organizationId } = payload;
    return `/collaboration/members/workspaces/${organizationId}?user_id=${userId}`;
};

export const fetch = (userId, teamId) => {
    const payload = {
        userId,
        organizationId: teamId
    };

    if (!userId || !teamId) {
        throw Error.create(
            'Invalid payload',
            TeamErrors.TEAM_FETCH_INVALID_PAYLOAD,
            payload
        );
    }

    return bop.get(fetchTeamUrl(payload))
        .after({ transformBody: transform.toCamelCase, statusCode: 200 })
        .run();
};
